<template>
  <div class="device-detail-sheet-history">
    <div class="box" style="margin-top: 16px">
      <div class="supportMode">
        <!-- 模式 -->
        <el-radio-group v-model="supportMode" @change="onSupportMode">
          <el-radio-button v-for="(item, index) in modeTypeList" :key="index" :label="item.label">
            {{ item.value }}
          </el-radio-button>
        </el-radio-group>
      </div>
      <div class="chart" ref="chart">
        <div class="legend">
          <ul>
            <template v-if="supportMode !== '1' && supportMode !== '4'&& supportMode !== '8'">
              <li>
                <i class="line"></i>
                {{ $t('dms_device_detail_sheet_history.qing_jie_shi_chang') }}
              </li>
              <li>
                <i class="interval-bule"></i>
                {{ $t('dms_device_detail_sheet_history.qing_jie_mian_ji') }}
              </li>
            </template>
            <template v-else-if="supportMode === '4' && supportMode !== '1' && supportMode !== '8'">
              <li>
                <i class="line"></i>
                {{ $t('dms_device_detail_sheet_history.jiao_xue_shi_chang') }}
              </li>
              <li>
                <i class="interval-bule"></i>
                {{ $t('dms_device_detail_sheet_history.jiao_xue_mian_ji') }}
              </li>
            </template>
            <template v-else-if="supportMode === '8' && supportMode !== '4' && supportMode !== '1'">
              <li>
                <i class="line"></i>
                {{ $t('dms_device_detail_sheet_history.kai_ji_shi_chang') }}
              </li>
            </template>
            <template v-else>
              <li>
                <i class="line"></i>
                {{ $t('dms_device_detail_sheet_history.chong_dian_shi_chang') }}
              </li>
            </template>
          </ul>
        </div>
      </div>
      <div class="slider" ref="slider"></div>
      <!-- v-show="0" -->
      <div class="scrollBarWrap">
        <ScrollBar ref="scrollBar" @updatePosRate="throttleUpdateDs" />
      </div>
    </div>
    <div class="sheet-info box">
      <ul class="box">
        <template v-for="func in deviceInfo.supportFunc.split(',')">
          <!-- 手工 -->
          <template v-if="func === 'manual'">
            <li class="item" :key="func">
              <p class="mode">{{ $t('dms_device_detail_sheet_history.ren_gong_qing_jie') }}</p>
              <ul>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_sheet_history.qing_jie_shi_changhm')">
                    {{ $t('dms_device_detail_sheet_history.qing_jie_shi_changhm') }}
                  </h2>
                  <p>{{ info.manualUsageTime === 0 ? '-' : $formatSecToHm(info.manualUsageTime) }}</p>
                </li>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_sheet_history.qing_jie_mian_jio', [$formatLenUnit()])">
                    {{ $t('dms_device_detail_sheet_history.qing_jie_mian_ji') }} {{$formatLenUnit()}}
                  </h2>
                  <p>{{ info.manualCleanArea === 0 ? '-' : $formatLenLocal($toFixed(info.manualCleanArea))| formatThousandth }}</p>
                </li>
                <li class="param">
                    <h2 :title="$t('dms_device_detail_sheet_history.qing_jie_ci_shu')">
                    {{ $t('dms_device_detail_sheet_history.qing_jie_ci_shu') }}
                    </h2>
                    <p>{{ info.manualUsageCount }}</p>
                  </li>
              </ul>
            </li>
          </template>
          <!-- 智能清洁-->
          <template v-else-if="func === 'autonomous'">
            <li class="item" :key="func">
              <p class="mode">{{ $t('dms_device_detail_sheet_history.zi_zhu_qing_jie') }}</p>
              <ul>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_sheet_history.qing_jie_shi_changhm')">
                    {{ $t('dms_device_detail_sheet_history.qing_jie_shi_changhm') }}
                  </h2>
                  <p>{{ info.autonomousUsageTime === 0 ? '-' : $formatSecToHm(info.autonomousUsageTime) }}</p>
                </li>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_sheet_history.qing_jie_mian_jio', [$formatLenUnit()])">
                    {{ $t('dms_device_detail_sheet_history.qing_jie_mian_ji') }} {{$formatLenUnit()}}
                  </h2>
                  <p>{{ info.autonomousCleanArea === 0 ? '-' : $formatLenLocal($toFixed(info.autonomousCleanArea)) | formatThousandth }}</p>
                </li>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_sheet_history.fu_zhu_ci_shu')">
                    {{ $t('dms_device_detail_sheet_history.fu_zhu_ci_shu') }}
                  </h2>
                  <p>{{ info.assistCount }}</p>
                </li>
              </ul>
            </li>
          </template>
          <!-- 教学 -->
          <template v-else-if="func === 'training'">
            <li class="item" :key="func">
              <p class="mode">{{ $t('dms_device_detail_sheet_history.jiao_xue') }}</p>
              <ul>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_sheet_history.jiao_xue_shi_changhm')">
                    {{ $t('dms_device_detail_sheet_history.jiao_xue_shi_changhm') }}
                  </h2>
                  <p>{{ info.trainingUsageTime === 0 ? '-' : $formatSecToHm(info.trainingUsageTime) }}</p>
                </li>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_sheet_history.jiao_xue_mian_jio', [$formatLenUnit()])">
                    {{ $t('dms_device_detail_sheet_history.jiao_xue_mian_ji') }} {{$formatLenUnit()}}
                  </h2>
                  <p>{{ info.trainingCleanArea === 0 ? '-' : $formatLenLocal($toFixed(info.trainingCleanArea))| formatThousandth }}</p>
                </li>
              </ul>
            </li>
          </template>
          <!-- 开机 -->
          <template v-else-if="func === 'boot'">
            <li class="item" :key="func">
              <p class="mode">{{ $t('dms_device_detail_sheet_history.kai_ji') }}</p>
              <ul>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_sheet_history.kai_ji_shi_changhm')">
                    {{$t('dms_device_detail_sheet_history.kai_ji_shi_changhm')}}
                  </h2>
                  <p>{{ info.bootTime === 0 ? '-' : $formatSecToHm(info.bootTime) }}</p>
                </li>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_sheet_history.kai_ji_ci_shu')">
                    {{$t('dms_device_detail_sheet_history.kai_ji_ci_shu')}}
                  </h2>
                  <p>{{ info.bootCount }}</p>
                </li>
              </ul>
            </li>
          </template>
          <!-- 充电 -->
          <template v-else-if="func === 'charging'">
            <li class="item" :key="func">
              <p class="mode">{{ $t('dms_device_detail_sheet_history.chong_dian') }}</p>
              <ul>
                <li class="param">
                  <h2 :title="$t('dms_device_detail_sheet_history.cdschm')">
                    {{ $t('dms_device_detail_sheet_history.cdschm') }}
                  </h2>
                  <p>{{ info.chargingTime === 0 ? '-' : $formatSecToHm(info.chargingTime) }}</p>
                </li>
              </ul>
            </li>
          </template>
        </template>

      </ul>
    </div>
    <div class="content">
      <div class="search-hd" style="padding: 0">
        <el-form :inline="true" @submit.native.prevent>
          <!-- <el-form-item>
            <p class="titel">
              {{ $t('page_content_historical_report_details }}
            </p>
          </el-form-item> -->

      <el-form-item >
        <!-- 模式 -->
        <el-radio-group v-model="formSearch.isSum" @change="onPageChange({page: 1})">
          <el-radio-button v-for="(item, index) in sumType" :key="index" :label="item.label">
            {{ item.value }}
          </el-radio-button>
        </el-radio-group>
      </el-form-item>
          <el-form-item style="float: right">
            <el-button class="table-set" style="vertical-align: top" @click="exportHistory">
              <i class="icon icon-daochu"></i>
            </el-button>
          </el-form-item>
          <!-- <el-form-item style="float: right">
            <switch-button :link="$refs.container"></switch-button>
          </el-form-item> -->
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table
          :data="historyList"
          v-if="isInch"
          tableCode="device_sheet_history_ft"
          :filterArr="filterArr"
          @filter="filterChange"
          @sort="sortChange"
          :slots="['manualCleanArea', 'autonomousCleanArea', 'trainingCleanArea']"
        >
          <!--
            manualCleanArea
            autonomousCleanArea
            trainingCleanArea
          -->
            <template v-slot:manualCleanArea="scope">
              <span>{{$formatLenLocal(scope.row.manualCleanArea)| formatThousandth}}</span>
            </template>
            <template v-slot:autonomousCleanArea="scope">
              <span>{{$formatLenLocal(scope.row.autonomousCleanArea)| formatThousandth}}</span>
            </template>
            <template v-slot:trainingCleanArea="scope">
              <span>{{$formatLenLocal(scope.row.trainingCleanArea)| formatThousandth}}</span>
            </template>
        </custom-table>
        <custom-table
          :data="historyList"
          v-else
          tableCode="device_sheet_history"
          :filterArr="filterArr"
          @filter="filterChange"
          @sort="sortChange"
        ></custom-table>
      </div>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
  </div>
</template>

<script>
import G2 from 'G2'; // 获取 Global 全局对象
import DataSet from '@antv/data-set';
import moment from 'moment';
// import Slider from '@antv/g2-plugin-slider';
import apis from '@/utils/apis';
import ScrollBar from './device_detail_sheet_scrollBar';

const { Global } = G2;

// 以10条作为基准
const BASE_LEN = 12;

export default {
  props: {
    deviceInfo: [Object, Array],
    reportType: [String, Number],

    // reportYearTime: [String, Number, Date],
    // reportYearTime: [String, Number, Date],
    // reportSeasonTime: [String, Number, Date],
    // reportMonthTime: [String, Number, Date],
    // reportWeekTime: [String, Number, Date]

    reportYearTime: [Array, Object],
    // reportSeasonTime: [String, Number, Date],
    reportSeasonTime: [Array, Object],
    // reportMonthTime: [String, Number, Date],
    reportMonthTime: [Array, Object],
    // reportWeekTime: [String, Number, Date]
    reportWeekTime: [Array, Object],
    reportDayTime: [Array, Object],
    isCharging: {
      type: Boolean,
      default: false,
    },
    isManual: {
      type: Boolean,
      default: false,
    },
    isAutonomous: {
      type: Boolean,
      default: false,
    },
    isTraining: {
      type: Boolean,
      default: false,
    },
    isBoot: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ScrollBar,
  },
  computed: {
    sumType() {
      let ret = [];
      ret = [
        {
          label: 1,
          value: this.$t('dms_device_detail_sheet_history.hui_zong'),
        },
        {
          label: 0,
          value: this.$t('dms_device_detail_sheet_history.ming_xi'),

        },
      ];
      return ret;
    },
  },
  data() {
    return {
      // chart: {},
      data: [],
      // data: [],

      formSearch: {
        pageNum: 1,
        pageSize: 20,
        reportType: this.reportType,
        // reportDate: this.reportMonthTime,
        beginTime: this.reportYearTime[0],
        endTime: this.reportYearTime[1],
        // deviceId: '460525870310076416'
        deviceId: this.deviceInfo.deviceId,
        bodyNum: this.deviceInfo.bodyNum,
        isSum: 1
      },
      reportDate: this.reportYearTime,
      monthList: [],
      info: {
        // ICE
        chargingTime: '', // 充电时长
        manualUsageTime: '', // 手工清洁时间
        manualCleanArea: '', // 手工清洁面积
        manualUsageCount: '', // 手工清洁次数
        lastDataUploadedTime: '', // 最后清洁时间
        // SBR
        // 手工清洁时长 h:m ,
        // 手工清洁面积 m²,
        autonomousUsageTime: '', // 智能清洁时长 h:m',
        autonomousCleanArea: '', // 智能清洁面积 m²',
        assistCount: '', // 辅助次数,
        trainingUsageTime: '', // 教学时长 h:m,
        trainingCleanArea: '', // 教学面积 m²,
        totalUsageCount: '', // 清洁次数,
        bootTime: '', // 开机时长 h:m,
        bootCount: '', // 开机次数,

      },
      // monthPage: [],
      historyList: [],
      totalRows: null,
      supportMode: '',
      modeTypeList: [],
      filterArr: [],
      iot_tsl_use_type2: {},
    };
  },
  watch: {
    reportType(val) {
      this.formSearch.reportType = val;
      // 重置分页
      this.formSearch.pageNum = 1;
      this.syncFilterArr();
      this.getReport(val);
    },
    reportYearTime() {
      // 重置分页
      this.formSearch.pageNum = 1;
      this.syncFilterArr();
      this.getReport(this.reportType);
    },
    reportSeasonTime() {
      // 重置分页
      this.formSearch.pageNum = 1;
      this.syncFilterArr();
      this.getReport(this.reportType);
    },
    reportMonthTime() {
      // 重置分页
      this.formSearch.pageNum = 1;
      this.syncFilterArr();
      this.getReport(this.reportType);
    },
    reportWeekTime() {
      // 重置分页
      this.formSearch.pageNum = 1;
      this.syncFilterArr();
      this.getReport(this.reportType);
    },
    reportDayTime() {
      // 重置分页
      this.formSearch.pageNum = 1;
      this.syncFilterArr();
      this.getReport(this.reportType);
    },
    'formSearch.isSum'() {
      this.syncFilterArr();
    },
  },
  created() {
    // 不需要与视图交互的变量都定义在created这里
    this.refreshTimer = null;
    this.scrollProportion = 0;
    this.chart = null;
    this.chartView = null;
    this.ds = null;
    this.data = [];
  },
  mounted() {
    // this.getTableColumn();
    this.getReport(this.reportType);
    this.getDictionary('iot_tsl_use_type2', (data) => {
      this.iot_tsl_use_type2 = this.$transformDicValue(data.iot_tsl_use_type2);
    });
    // 设置模式
    this.setModeTypeList();
  },
  methods: {
    // 动态同步 filterArr
    syncFilterArr() {
      const arr = [];
      // 充电
      if (!this.isCharging) {
        arr.push('chargingTimeFormat');
      }
      // 手工
      if (!this.isManual) {
        arr.push('manualUsageTimeFormat', 'manualCleanArea');
      }
      // 智能
      if (!this.isAutonomous) {
        arr.push('autonomousUsageTimeFormat', 'autonomousCleanArea', 'assistCount');
      }
      // 教学
      if (!this.isTraining) {
        arr.push('trainingUsageTimeFormat', 'trainingCleanArea');
      }
      // 教学
      if (!this.isBoot) {
        arr.push('bootTimeFormat', 'bootCount');
      }
      // isSum=1 时增加字段
      if (this.formSearch.isSum === 1) {
        arr.push('locationName', 'siteName', 'orgName');
      }
      this.filterArr = arr;
    },
    // 设置模式
    setModeTypeList() {
      const list = [];
      this.syncFilterArr();

      this.deviceInfo.supportFunc.split(',').forEach((func) => {
        // 手工
        if (func === 'manual') {
          list.push({ label: '2', value: this.iot_tsl_use_type2['2'] });
        }
        // 智能
        if (func === 'autonomous') {
          list.push({ label: '5', value: this.iot_tsl_use_type2['5'] });
        }
        // 教学
        if (func === 'training') {
          list.push({ label: '4', value: this.iot_tsl_use_type2['4'] });
        }
        // 开机
        if (func === 'boot') {
          list.push({ label: '8', value: this.iot_tsl_use_type2['8'] });
        }

        // 充电
        if (func === 'charging') {
          list.push({ label: '1', value: this.iot_tsl_use_type2['1'] });
        }
      });

      if (list.length > 0) {
        this.supportMode = list[0].label;
      }
      this.modeTypeList = list;
    },

    getReport: function (reportType) {
      if (reportType === '1') {
        this.reportDate = this.reportYearTime;
        this.formSearch.beginTime = this.reportYearTime[0];
        this.formSearch.endTime = this.reportYearTime[1];
        // 年报表
        // 图表
        this.getReportYearlist();
        // table
        this.getReportYearPage();
        // info
        this.getInfo();
      } else if (reportType === '2') {
        this.reportDate = this.reportSeasonTime;
        this.formSearch.beginTime = this.reportSeasonTime[0];
        this.formSearch.endTime = this.reportSeasonTime[1];
        // 月报表
        // 图表
        this.getReportYearlist();
        // table
        this.getReportYearPage();
        // info
        this.getInfo();
      } else if (reportType === '3') {
        this.reportDate = this.reportMonthTime;
        this.formSearch.beginTime = this.reportMonthTime[0];
        this.formSearch.endTime = this.reportMonthTime[1];
        // 月报表
        // 图表
        this.getReportMonthlist();
        // table
        this.getReportMonthPage();
        // info
        this.getInfo();
      } else if (reportType === '4') {
        this.reportDate = this.reportWeekTime;
        // this.formSearch.reportDate = moment(
        //   new Date(this.reportWeekTime)
        // ).format('GGGG-WW'); // 转换时间因为现在是Date类型

        // moment.localeData().firstDayOfWeek(6);
        // 设置周的开始时间是星期一 1月1号是年开始的第一周
        moment.updateLocale('en', {
          week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 4th is the first week of the year.// 年份的第一周必须包含1月1日 (7 + 1 - 1)
          },
        });
        // .toDate()
        this.formSearch.beginTime = moment(this.reportWeekTime[0]).format('gggg-ww'); // 转换时间因为现在是Date类型
        this.formSearch.endTime = moment(this.reportWeekTime[1]).format('gggg-ww'); // 转换时间因为现在是Date类型

        // 月报表
        // 图表
        this.getReportMonthlist();
        // table
        this.getReportMonthPage();
        // info
        this.getInfo();
      } else if (reportType === '5') {
        this.reportDate = this.reportDayTime;
        this.formSearch.beginTime = this.reportDayTime[0];
        this.formSearch.endTime = this.reportDayTime[1];
        // 月报表
        // 图表
        this.getReportDaylist();
        // table
        this.getReportDayPage();
        // info
        this.getDayInfo();
      }
    },
    // 月报表 周 图表
    getReportMonthlist: function () {
      this.$getJSON(apis.DeviceReportSummaryList, this.formSearch).then((res) => {
        if (this.reportType === '3' || this.reportType === '4') {
          this.monthList = res.data;
          // this.data = res.data;
          const data = res.data;
          data.forEach((i) => {
            i.totalUsageTimeMin = this.$formatSecToMin(i.totalUsageTime);
            i.chargingTimeMin = this.$formatSecToMin(i.chargingTime);
            i.manualUsageTimeMin = this.$formatSecToMin(i.manualUsageTime);
            i.trainingUsageTimeMin = this.$formatSecToMin(i.trainingUsageTime);
            i.autonomousUsageTimeMin = this.$formatSecToMin(i.autonomousUsageTime);
            i.totalCleanArea = this.$formatLenLocal(i.totalCleanArea);
            i.manualCleanArea = this.$formatLenLocal(i.manualCleanArea);
            i.autonomousCleanArea = this.$formatLenLocal(i.autonomousCleanArea);
            i.trainingCleanArea = this.$formatLenLocal(i.trainingCleanArea);
            i.bootTimeMin = this.$formatSecToMin(i.bootTime);
          });
          this.data = data;
          // 生成图表
          this.onSupportMode(this.supportMode);
        }
      });
    },
    // 日报表
    getReportDaylist: function () {
      this.$getJSON(apis.deviceReportDailyList, {
        ...this.formSearch,
        // 字段改了要用startDate endDate传时间 天的格式
        startDate: this.$momentElLocal(this.formSearch.beginTime, 'YYYY-MM-DD'),
        endDate: this.$momentElLocal(this.formSearch.endTime, 'YYYY-MM-DD')
      }).then((res) => {
        if (this.reportType === '5') {
          this.monthList = res.data;
          // this.data = res.data;
          const data = res.data;
          data.forEach((i) => {
            i.totalUsageTimeMin = this.$formatSecToMin(i.totalUsageTime);
            i.chargingTimeMin = this.$formatSecToMin(i.chargingTime);
            i.manualUsageTimeMin = this.$formatSecToMin(i.manualUsageTime);
            i.trainingUsageTimeMin = this.$formatSecToMin(i.trainingUsageTime);
            i.autonomousUsageTimeMin = this.$formatSecToMin(i.autonomousUsageTime);
            i.totalCleanArea = this.$formatLenLocal(i.totalCleanArea);
            i.manualCleanArea = this.$formatLenLocal(i.manualCleanArea);
            i.autonomousCleanArea = this.$formatLenLocal(i.autonomousCleanArea);
            i.trainingCleanArea = this.$formatLenLocal(i.trainingCleanArea);
            i.bootTimeMin = this.$formatSecToMin(i.bootTime);
          });
          this.data = data;
          // 生成图表
          this.onSupportMode(this.supportMode);
        }
      });
    },
    // 日 table
    getReportDayPage: function () {
      this.$getJSON(apis.deviceReportDailyPage, {
        ...this.formSearch,
        // 字段改了要用startDate endDate传时间 天的格式
        startDate: this.$momentElLocal(this.formSearch.beginTime, 'YYYY-MM-DD'),
        endDate: this.$momentElLocal(this.formSearch.endTime, 'YYYY-MM-DD'),
      }).then((res) => {
        if (this.reportType === '5') {
          // this.historyList = res.data.list;
          const data = res.data.list || [];
          this.nullValueToCrossbar(data, ['assistCount']);
          this.historyList = data;
          this.totalRows = res.data.total;
        }
      });
    },
    // 月 周 table
    getReportMonthPage: function () {
      this.$getJSON(apis.DeviceReportSummaryPage, this.formSearch).then((res) => {
        if (this.reportType === '3' || this.reportType === '4') {
          // this.historyList = res.data.list;
          const data = res.data.list || [];
          this.nullValueToCrossbar(data, ['assistCount']);
          this.historyList = data;
          this.totalRows = res.data.total;
        }
      });
    },
    // 年报表 季度 图表
    getReportYearlist: function () {
      this.$getJSON(apis.DeviceReportSummaryList, this.formSearch).then((res) => {
        if (this.reportType === '1' || this.reportType === '2') {
          this.monthList = res.data;
          // this.data = res.data;
          const data = res.data;
          data.forEach((i) => {
            i.totalUsageTimeMin = this.$formatSecToMin(i.totalUsageTime);
            i.chargingTimeMin = this.$formatSecToMin(i.chargingTime);
            i.manualUsageTimeMin = this.$formatSecToMin(i.manualUsageTime);
            i.trainingUsageTimeMin = this.$formatSecToMin(i.trainingUsageTime);
            i.autonomousUsageTimeMin = this.$formatSecToMin(i.autonomousUsageTime);
            i.totalCleanArea = this.$formatLenLocal(i.totalCleanArea);
            i.manualCleanArea = this.$formatLenLocal(i.manualCleanArea);
            i.autonomousCleanArea = this.$formatLenLocal(i.autonomousCleanArea);
            i.trainingCleanArea = this.$formatLenLocal(i.trainingCleanArea);
            i.bootTimeMin = this.$formatSecToMin(i.bootTime);
          });
          this.data = data;
          // 生成图表
          this.onSupportMode(this.supportMode);
        }
      });
    },
    // 年报表 季度 table
    getReportYearPage: function () {
      this.$getJSON(apis.DeviceReportSummaryPage, this.formSearch).then((res) => {
        if (this.reportType === '1' || this.reportType === '2') {
          // this.historyList = res.data.list;
          const data = res.data.list || [];
          this.nullValueToCrossbar(data, ['assistCount']);
          this.historyList = data;
          this.totalRows = res.data.total;
        }
      });
    },
    // 日 info
    getDayInfo: function () {
      this.$getJSON(apis.DeviceReportDaily, {
        ...this.formSearch,
        // reportType: 1,
        // reportDate: '2019',
        // deviceId: '460525870310076416'
        reportType: this.reportType,
        reportDate: this.formSearch.reportDate,
        deviceId: this.deviceInfo.deviceId,
        bodyNum: this.deviceInfo.bodyNum,
        // 字段改了要用startDate endDate传时间 天的格式
        startDate: this.$momentElLocal(this.formSearch.beginTime, 'YYYY-MM-DD'),
        endDate: this.$momentElLocal(this.formSearch.endTime, 'YYYY-MM-DD'),
      }).then((res) => {
        if (this.reportType === '5') {
          if (res.data && Object.keys(res.data).length !== 0) {
            // 有可能是没哟值的 先自己定义为0
            this.info.chargingTime = res.data.chargingTime ? res.data.chargingTime : 0;
            this.info.manualUsageTime = res.data.manualUsageTime ? res.data.manualUsageTime : 0;
            this.info.autonomousUsageTime = res.data.autonomousUsageTime ? res.data.autonomousUsageTime : 0;
            this.info.trainingUsageTime = res.data.trainingUsageTime ? res.data.trainingUsageTime : 0;
            this.info.bootTime = res.data.bootTime ? res.data.bootTime : 0;
            this.$setFormatData(this.info, res.data);
          } else {
            this.info.chargingTime = '';
            this.info.manualUsageTime = '';
            this.info.manualRunLength = '';
            this.info.manualCleanArea = '';
            this.info.autonomousUsageTime = '';
            this.info.autonomousRunLength = '';
            this.info.autonomousCleanArea = '';
            this.info.trainingUsageTime = '';
            this.info.trainingRunLength = '';
            this.info.trainingCleanArea = '';
            this.info.assistCount = '';
            this.info.bootTime = '';
            this.info.bootCount = '';
            this.info.manualUsageCount = '';// 手工清洁次数
            this.info.totalUsageCount = '';// 清洁次数
          }
        }
      });
    },
    // 年报表 季度 月 周 info
    getInfo: function () {
      this.$getJSON(apis.DeviceReportSummaryInfo, {
        ...this.formSearch,
        // reportType: 1,
        // reportDate: '2019',
        // deviceId: '460525870310076416'
        reportType: this.reportType,
        reportDate: this.formSearch.reportDate,
        deviceId: this.deviceInfo.deviceId,
      }).then((res) => {
        if (res.data && Object.keys(res.data).length !== 0) {
          // 有可能是没哟值的 先自己定义为0
          this.info.chargingTime = res.data.chargingTime ? res.data.chargingTime : 0;
          this.info.manualUsageTime = res.data.manualUsageTime ? res.data.manualUsageTime : 0;
          this.info.autonomousUsageTime = res.data.autonomousUsageTime ? res.data.autonomousUsageTime : 0;
          this.info.trainingUsageTime = res.data.trainingUsageTime ? res.data.trainingUsageTime : 0;
          this.info.bootTime = res.data.bootTime ? res.data.bootTime : 0;
          this.$setFormatData(this.info, res.data);
        } else {
          this.info.chargingTime = '';
          this.info.manualUsageTime = '';
          this.info.manualRunLength = '';
          this.info.manualCleanArea = '';
          this.info.autonomousUsageTime = '';
          this.info.autonomousRunLength = '';
          this.info.autonomousCleanArea = '';
          this.info.trainingUsageTime = '';
          this.info.trainingRunLength = '';
          this.info.trainingCleanArea = '';
          this.info.assistCount = '';
          this.info.bootTime = '';
          this.info.bootCount = '';
          this.info.manualUsageCount = '';// 手工清洁次数
          this.info.totalUsageCount = '';// 清洁次数
        }
      });
    },
    // 导出数据
    exportHistory: function () {
      if (this.reportType === '5') {
        this.$exportFlie(apis.deviceReportDailyExport, {
          ...this.formSearch,
          reportType: this.reportType,
          deviceId: this.deviceInfo.deviceId,
          excludeColumnList: this.filterArr,
          // 字段改了要用startDate endDate传时间 天的格式
          startDate: this.$momentElLocal(this.formSearch.beginTime, 'YYYY-MM-DD'),
          endDate: this.$momentElLocal(this.formSearch.endTime, 'YYYY-MM-DD')
        }).then(() => {});
      } else {
        this.$exportFlie(apis.DeviceReportHistoryExport, {
          ...this.formSearch,
          reportType: this.reportType,
          deviceId: this.deviceInfo.deviceId,
          excludeColumnList: this.filterArr,
        }).then(() => {});
      }

    },
    updateChart() {
      let baseRate = 1;
      const data = this.data;
      if (this.data.length > BASE_LEN) {
        baseRate = BASE_LEN / this.data.length;
      }
      this.scrollProportion = baseRate;

      this.ds.getView('origin').source(data);
      // this.chart.changeData(data);

      // 设置tooltip别名   字段转中文
      // this.chart.scale('reportDate', {
      //   // 各个属性配置
      //   // alias: useTips, // 为属性定义别名
      //   // type: 'timeCat'  // 日期类型 yyyy-mm-dd
      //   type: 'cat' // 日期yyyy-mm 用字符串
      //   // type: this.reportDate === 1 || this.reportDate === 2 ? 'cat' : 'timeCat'
      // });

      let currentPos = this.ds.state.start;
      // 处理边界情况
      if (currentPos + this.scrollProportion > 1) {
        currentPos = 1 - this.scrollProportion;
      }
      let endPos = Math.min(1, currentPos + this.scrollProportion);
      // 处理精度误差问题
      if (1 - endPos < 1 / this.data.length) {
        endPos = 1;
      }
      this.ds.setState('start', currentPos);
      this.ds.setState('end', endPos);
      this.$refs.scrollBar.initScroll(baseRate);
      this.chartView.guide().clear();
      // this.setChartViewGuide();
      // 让guide可以刷新，同时让tooltip刷新
      this.chart.repaint();
      this.chart.render();
      this.$refs.scrollBar.initScroll(this.scrollProportion, this.ds.state.start);
    },
    throttleUpdateDs: function updateDs(rate) {
      this.ds.setState('start', rate);
      let endPos = rate + this.scrollProportion;
      // 处理精度误差问题
      if (1 - endPos < 1 / this.data.length) {
        endPos = 1;
      }

      this.ds.setState('end', endPos);
    },
    // 模式
    onSupportMode: function (val) {
      if (this.chart) {
        this.chart.destroy();
      }
      switch (val) {
        // 充电
        case '1':
          this.initChargChart('chargingTimeMin');
          break;
        // 手工
        case '2':
          // this.initChart('manualCleanArea', 'manualUsageTimeFormat');
          this.initChart('manualCleanArea', 'manualUsageTimeMin');
          break;
        // 智能
        case '5':
          // this.initChart('autonomousCleanArea', 'autonomousUsageTimeFormat');
          this.initChart('autonomousCleanArea', 'autonomousUsageTimeMin');
          break;
        // 开机
        case '8':
          this.initChargChart('bootTimeMin');
          break;
        default:
          // 教学 4
          // this.initChart('trainingCleanArea', 'trainingUsageTimeFormat');
          this.initChart('trainingCleanArea', 'trainingUsageTimeMin');
      }
    },

    initChargChart: function (intervalName) {
      const timeMinType = intervalName === 'chargingTimeMin' ? this.$t('dms_device_detail_sheet_history.cdscmin') : this.$t('dms_device_detail_sheet_history.kai_ji_shi_changmin');
      Global.registerTheme('newTheme', {
        colors: ['#6DC2ED', '#394668', 'yellow'],
      }); // 传入两个参数，一个参数是主题的名称，另一个参数是主题配置项
      const chargingTips = timeMinType;
      let baseRate = 1;
      const data = this.data;
      if (this.data.length > BASE_LEN) {
        baseRate = BASE_LEN / this.data.length;
      }
      this.scrollProportion = baseRate;
      // 修改：传入第二个参数使滚动条从最右边开始
      const startPos = 1 - baseRate;
      this.$refs.scrollBar.initScroll(baseRate, startPos);

      this.ds = new DataSet({
        state: {
          // 修改：从最右边开始显示
          start: startPos,
          end: 1,
        },
      });
      const dv = this.ds.createView('origin').source(data);
      dv.transform({
        type: 'filter',
        groupBy: ['category'],
        // callback: (obj, index, arr) => (index + 1) / arr.length >= this.ds.state.start && (index + 1) / arr.length <= this.ds.state.end
        callback: (obj) => {
          const newIndex = this.data.findIndex(i => i.reportDate === obj.reportDate);
          return (newIndex + 1) / this.data.length >= this.ds.state.start && (newIndex + 1) / this.data.length <= this.ds.state.end;
        },
      });

      this.chart = new G2.Chart({
        container: this.$refs['chart'],
        forceFit: true,
        height: 350,
        theme: 'newTheme',
        // padding: ['40', 'auto', '40', 'auto']
        // padding: 40
        padding: [50, 'auto', 40, 'auto'],
      });
      this.chart.scale(`${intervalName}`, {
        min: 0,
        // 各个属性配置
        // type: 'identity' // 日期yyyy-mm 用字符串
      });
      // 设置tooltip别名   字段转中文
      this.chart.scale('reportDate', {
        // 各个属性配置
        // alias: useTips, // 为属性定义别名
        // type: 'timeCat'  // 日期类型 yyyy-mm-dd
        type: 'cat', // 日期yyyy-mm 用字符串
        // type: this.reportDate === 1 || this.reportDate === 2 ? 'cat' : 'timeCat'
      });

      this.chartView = this.chart.view();
      this.chartView.source(dv, {
        // 'chargingTimeMin': {
        //   tickCount: 6, // 设置了刻度回上下加 所以会出现小于min的值
        // }
      });

      // 最左边单位
      this.chartView.guide().text({
        top: true, // 指定 giude 是否绘制在 canvas 最上层，默认为 false, 即绘制在最下层
        position: ['start', 'end'], // 文本的起始位置，值为原始数据值，支持 callback
        content: chargingTips,
        style: {
          fill: '#98A6AD ', // 文本颜色
          fontSize: '12', // 文本大小
        }, // 文本的图形样式属性
        offsetX: -30, // x 方向的偏移量
        offsetY: -20, // y 方向偏移量
      });
      this.chartView.axis(`${intervalName}`, {
        label: {
          textStyle: {
            fill: '#98A6AD', // 文本的颜色
          },
        },
        line: {
          lineWidth: 1, // 设置线的宽度
          stroke: '#DEE2E6', // 设置线的颜色
        },
        // grid: {
        //   lineStyle: {
        //     stroke: '#DEE2E6',
        //     lineWidth: 1,
        //     lineDash: [1, 0]
        //   },
        // }
      });
      this.chartView.axis('reportDate', {
        label: {
          textStyle: {
            fill: '#6C757D', // 文本的颜色
          },
        },
        // label: null
      });
      this.chartView
        .line()
        .position(`reportDate*${intervalName}`)
        .tooltip(`reportDate*${intervalName}`, (name, value) => ({
          name: timeMinType,
          value,
        }))
        .color('#5AD8A6');

      this.chart.render();
    },
    initChart: function (intervalName, lineName) {
      Global.registerTheme('newTheme', {
        colors: ['#6DC2ED', '#394668', 'yellow'],
      }); // 传入两个参数，一个参数是主题的名称，另一个参数是主题配置项

      // 时间（h） 面积（㎡）
      const chargingTips = this.$t('dms_device_detail_sheet_history.qjscmin');
      const cleanTips = this.$t('dms_device_detail_sheet_history.qing_jie_mian_jio', [this.$formatLenUnit()]);

      let baseRate = 1;
      const data = this.data;
      if (this.data.length > BASE_LEN) {
        baseRate = BASE_LEN / this.data.length;
      }
      this.scrollProportion = baseRate;
      const startPos = 1 - baseRate;
      this.$refs.scrollBar.initScroll(baseRate, startPos);
      this.ds = new DataSet({
        state: {
          // 修改：从最右边开始显示
          start: startPos,
          end: 1,
        },
      });
      const dv = this.ds.createView('origin').source(data);
      dv.transform({
        type: 'filter',
        groupBy: ['category'],
        // callback: (obj, index, arr) => (index + 1) / arr.length >= this.ds.state.start && (index + 1) / arr.length <= this.ds.state.end
        callback: (obj) => {
          const newIndex = this.data.findIndex(i => i.reportDate === obj.reportDate);
          return (newIndex + 1) / this.data.length >= this.ds.state.start && (newIndex + 1) / this.data.length <= this.ds.state.end;
        },
      });

      this.chart = new G2.Chart({
        container: this.$refs['chart'],
        forceFit: true,
        height: 350,
        theme: 'newTheme',
        // padding: ['40', 'auto', '40', 'auto']
        // padding: 40
        padding: [50, 'auto', 40, 'auto'],
      });

      // 设置tooltip别名   字段转中文
      this.chart.scale('reportDate', {
        // 各个属性配置
        // alias: useTips, // 为属性定义别名
        // type: 'timeCat'  // 日期类型 yyyy-mm-dd
        type: 'cat', // 日期yyyy-mm 用字符串
        // type: this.reportDate === 1 || this.reportDate === 2 ? 'cat' : 'timeCat'
      });
      //

      this.chart.scale(`${lineName}`, {
        min: 0,

        // 各个属性配置
      });
      this.chart.scale(`${intervalName}`, {
        min: 0,
        // 各个属性配置
        alias: cleanTips, // 为属性定义别名
        type: 'linear'
      });
      this.chartView = this.chart.view();
      this.chartView.source(dv, {
        cleanedArea: {
          tickCount: 6,
        },
        // chargingTimeFormat: {
        //   tickCount: 6
        // }
      });

      // 最左边单位
      this.chartView.guide().text({
        top: true, // 指定 giude 是否绘制在 canvas 最上层，默认为 false, 即绘制在最下层
        position: ['start', 'end'], // 文本的起始位置，值为原始数据值，支持 callback
        content: chargingTips,
        style: {
          fill: '#98A6AD ', // 文本颜色
          fontSize: '12', // 文本大小
        }, // 文本的图形样式属性
        offsetX: -30, // x 方向的偏移量
        offsetY: -20, // y 方向偏移量
      });
      // 最右边单位
      this.chartView.guide().text({
        top: true, // 指定 giude 是否绘制在 canvas 最上层，默认为 false, 即绘制在最下层
        position: ['end', 'end'], // 文本的起始位置，值为原始数据值，支持 callback
        // .position('time*clean')
        content: cleanTips,
        style: {
          fill: '#98A6AD', // 文本颜色
          fontSize: '12', // 文本大小
        }, // 文本的图形样式属性
        offsetX: -20, // x 方向的偏移量
        offsetY: -20, // y 方向偏移量

        // alignX: 'right',
        // alignY: 'top',
      });

      this.chartView
        .line()
        .position(`reportDate*${lineName}`)
        .tooltip(`reportDate*${lineName}`, (name, value) => ({
          name: this.$t('dms_device_detail_sheet_history.qjscmin'),
          value,
        }))
        .color('#5AD8A6');

      this.chartView.interval().position(`reportDate*${intervalName}`).color('#55B8E9').size(30);
      // .tooltip(false);
      this.chart.legend(false); // 关掉自带图例

      // 不要y轴
      this.chartView.axis(`${lineName}`, {
        label: {
          textStyle: {
            fill: '#98A6AD', // 文本的颜色
          },
        },
        line: {
          lineWidth: 1, // 设置线的宽度
          stroke: '#DEE2E6', // 设置线的颜色
        },
        // grid: {
        //   lineStyle: {
        //     stroke: '#DEE2E6',
        //     lineWidth: 1,
        //     lineDash: [1, 0]
        //   },
        // }
      });

      this.chartView.axis(`${intervalName}`, {
        grid: null,
        label: {
          textStyle: {
            fill: '#98A6AD', // 文本的颜色
          },
        },
        line: {
          lineWidth: 1, // 设置线的宽度
          stroke: '#DEE2E6', // 设置线的颜色
        },
        // label: null
      });
      this.chartView.axis('reportDate', {
        label: {
          textStyle: {
            fill: '#6C757D', // 文本的颜色
          },
        },
        // label: null
      });
      this.chart.render();
    },

    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.syncFilterArr();
      if (this.reportType === '1' || this.reportType === '2') {
        // table
        this.getReportYearPage();
      } else if (this.reportType === '3' || this.reportType === '4') {
        // table
        this.getReportMonthPage();
      } else if (this.reportType === '5') {
        this.getReportDayPage();
      }

    },
  },
};
</script>

<style lang="scss">
.device-detail-sheet-history {
  .supportMode {
    margin-bottom: 24px;
  }

  .chart {
    // padding: 0 24px;
    background-color: #fff;
    position: relative;
    .legend {
      position: absolute;
      left: 50%;
      top: 10px;
      transform: translateX(-50%);
      ul {
        display: flex;
        li {
          height: 17px;
          font-size: 12px;
          color: rgba(108, 117, 125, 1);
          line-height: 17px;
          margin-right: 20px;
          i {
            display: inline-block;
            width: 10px;
            height: 10px;
            margin-right: 3px;
          }
          .line {
            height: 3px;
            vertical-align: middle;
            background-color: #5ad8a6;
          }
          .interval-bule {
            background-color: #6dc2ed;
          }
          // .interval-black {
          //   background-color: #253048;
          // }
        }
      }
    }
  }
  .scrollBarWrap {
    margin-left: 36px;
    padding-block: 13px;
  }
  .sheet-info {
    margin-top: 16px;
    .box {
      padding: 0px 16px;
      display: flex;
      li.item {
        border-right: 1px solid #e9ebec;
        margin-left: 32px;
        &:first-child {
          margin: 0;
        }
        .mode {
          height: 28px;
          font-size: 15px;
          font-weight: bold;
          color: #0d9ae0;
          line-height: 28px;
          margin-bottom: 12px;
        }
        ul {
          display: flex;
          .param {
            padding-right: 32px;
            h2 {
              height: 17px;
              font-size: 12px;
              color: rgba(152, 166, 173, 1);
              line-height: 17px;
              margin-bottom: 5px;
              white-space: normal;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            p {
              height: 26px;
              font-size: 22px;
              font-weight: bold;
              color: rgba(57, 70, 104, 1);
              line-height: 26px;
            }
          }
        }

        &:last-of-type {
          border: none;
        }
      }
    }
    .time {
      color: #0d9ae0;
    }
    .box-bottom {
      margin-top: 16px;
      text-align: right;
      height: 17px;
      font-size: 12px;
      color: #98a6ad;
      line-height: 17px;
    }
  }
  .content {
    margin-top: 16px;
    padding: 24px;
    background-color: #fff;
    // display: flex;
    // flex-direction: column;
    // height: 100%;
    // margin-top: 24px;
    .head {
      margin-bottom: 8px;
      display: flex;
      justify-content: space-between;
      p {
        height: 28px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(73, 80, 87, 1);
        line-height: 28px;
      }
    }
    .table-bd {
      padding-top: 26px;
    }
  }
}
</style>
